import { render, staticRenderFns } from "./education-dialog.vue?vue&type=template&id=0c148163&"
import script from "./education-dialog.vue?vue&type=script&lang=js&"
export * from "./education-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports